'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POSITIONS = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POSITIONS = exports.POSITIONS = {
  LEFT: 'left',
  RIGHT: 'right'
};

var Label = function Label(_ref) {
  var className = _ref.className,
      htmlFor = _ref.htmlFor,
      labelText = _ref.labelText,
      labelUia = _ref.labelUia,
      style = _ref.style,
      props = (0, _objectWithoutProperties3.default)(_ref, ['className', 'htmlFor', 'labelText', 'labelUia', 'style']);

  return _react2.default.createElement(
    'label',
    {
      'data-uia-label': labelUia,
      className: className,
      htmlFor: htmlFor,
      style: style
    },
    props.children || labelText
  );
};

Label.defaultProps = {
  labelText: 'LabelText'
};

exports.default = Label;